<template>
    <div class="logupWrap fc ac">
        <!-- <h2 class="title">注册/登录</h2> -->
        <div class="top fc ac jc">
            <img :src="isKfc ? kfcLogoIco : logoIco" alt />
        </div>
        <span class="area">中国(+86)</span>
        <input type="text" v-model="phoneNo" placeholder="请输入手机号码" class="phoneNoIpt" />
        <button class="getCodeBtn" @click="getCode">获取验证码</button>

        <!-- <div class="rowBox fc ac">
            <div class="row fr ac">
                <img src="../../../static/imgs/logUp/phone.png" alt="" class="rowIco">
                <input v-model="phoneNo" class="phoneIpt" placeholder="手机号码（+86）" type="text" />
            </div>
            <div class="row fr ac">
                <img src="../../../static/imgs/logUp/pwd.png" alt="" class="rowIco">
                <input v-model="code" class="codeIpt" placeholder="请输入短信验证码" maxlength="6" type="text" />
                <button v-if="!disabled" @click="getCode" class="codeBtn bg_tc">获取验证码</button>
                <button v-else class="codeBtn bg_grey">{{time}}s后重新发送</button>
            </div>
        </div>
        <div @click="switchAgree" class="agreement fr ac">
            <img class="selectIco" :src="isAgree ? selectedIco : selectIco" alt="">
            <span>我已阅读并同意《用户注册协议》</span>
        </div>
        <button @click="login" class="logupBtn bg_tc">登陆</button>-->

        <!-- <div class="loginWith fc ac">
            <div class="txt fr ac"><b></b>第三方登录<b></b></div>
            <div class="method fc ac">
                <img src="../../../static/imgs/logUp/wechat.png" alt="">
                <span>微信</span>
            </div>
        </div>-->
    </div>
</template>


<script>
import { Toast } from "mint-ui";
export default {
    data() {
        return {
            phoneNo: "", //手机号码
            code: "", //验证码
            disabled: false,
            time: 60,
            interval: null,
            isAgree: true,
            selectIco: require("../../../static/imgs/logUp/select.png"),
            selectedIco: require("../../../static/imgs/logUp/selected.png"),
            logoIco: require("../../../static/imgs/logUp/logo.png"),
            kfcLogoIco: require("../../../static/imgs/kfc/kfc.png"),
            isKfc: this.$route.query.isKfc ? this.$route.query.isKfc : ""
        };
    },
    beforeRouteEnter(to, from, next) {
        // window.document.body.style.backgroundColor = "#FFC900";
        window.document.body.style.backgroundColor = "#FFF";
        next();
    },
    beforeRouteLeave(to, from, next) {
        window.document.body.style.backgroundColor = "#f2f2f2";
        next();
    },
    created() {
        console.log("query", this.$route);
    },
    methods: {
        switchAgree() {
            this.isAgree = !this.isAgree;
        },
        getCode() {
            // let redirect = decodeURIComponent(
            //     this.$route.query.redirect ? this.$route.query.redirect : "/"
            // );
            // console.log(redirect);
            // this.setLocal("auth_code", "123456")
            // this.setLocal("hasLogged", true);
            // this.$router.push({ path: redirect });
            // return;
            let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (!this.phoneNo) {
                Toast({
                    message: "请输入手机号码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            } else if (!phoneReg.test(this.phoneNo)) {
                Toast({
                    message: "请输入正确的手机号码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            }
            this.$post({
                method: "auth.login.verify.send",
                mobile: this.phoneNo
            }).then(res => {
                if (res.success) {
                    // this.countDown();
                    // this.disabled = true;
                    this.$router.push({
                        path: "/enterCode",
                        query: { phoneNo: this.phoneNo, isKfc: this.isKfc,  redirect: this.$route.query.redirect }
                    });
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                }
            });
        },
        countDown() {
            this.interval = null;
            var time = this.time;
            this.interval = setInterval(() => {
                time--;
                this.time = time;
                if (time < 1) {
                    clearInterval(this.interval);
                    this.disabled = false;
                    this.time = 120;
                }
            }, 1000);
        },
        login() {
            if (!this.phoneNo) {
                Toast({
                    message: "请输入手机号码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            } else if (!this.code) {
                Toast({
                    message: "请输入验证码",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            } else if (!this.isAgree) {
                Toast({
                    message: "请阅读并同意协议",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            }
            this.$post({
                method: "auth.login.verify.verify",
                mobile: this.phoneNo,
                verify: this.code
            }).then(res => {
                if (res.success) {
                    this.setLocal("hasLogged", true);
                    this.setLocal("auth_code", res.data.auth_code);
                    this.setLocal("phoneNo", this.phoneNo);
                    let redirect = decodeURIComponent(
                        this.$route.query.redirect
                            ? this.$route.query.redirect
                            : "/"
                    );
                    console.log(redirect);
                    this.$router.push({ path: redirect });
                } else {
                    Toast({
                        message: res.error.desp,
                        position: "middle",
                        duration: 2000,
                        className: "toastBox"
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss">
.logupWrap {
    // background: #ffc900;
    .top {
        width: 100%;
        height: 276px;
        background-image: url(../../../static/imgs/movie/top_bg.png);
        background-size: cover;
        background-position: center;
        img {
            width: 120px;
            height: 120px;
        }
    }
    .area {
        font-size: 28px;
        width: 100%;
        padding: 0 60px;
        box-sizing: border-box;
        margin: 50px 0 20px 0;
    }
    .phoneNoIpt {
        height: 98px;
        width: calc(100% - 120px);
        border-bottom: 1px solid #c9c9c9;
        font-size: 40px;
    }
    .getCodeBtn {
        width: calc(100% - 120px);
        height: 98px;
        margin-top: 60px;
        font-size: 32px;
        color: #fff;
        border-radius: 49px;
        background: #f90040;
    }
    .title {
        font-size: 28px;
        height: 98px;
        line-height: 98px;
    }
    .logo {
        width: 150px;
        height: 150px;
        margin: 60px 0 60px 0;
    }
    .rowBox {
        width: 670px;
        background: #fff;
        border-radius: 10px;
        font-size: 26px;
        .row {
            width: 100%;
            height: 120px;
            padding: 0 10px;
            box-sizing: border-box;
            .rowIco {
                width: 55px;
                height: 55px;
            }
            input {
                padding: 0 20px;
                box-sizing: border-box;
                height: 60px;
                border-left: 1px solid #ddd;
                margin-left: 10px;
            }
            .phoneIpt {
                width: 580px;
            }
            .codeIpt {
                width: 320px;
            }
            .codeBtn {
                width: 240px;
                height: 60px;
                color: #fff;
                background: #ffc900;
                border-radius: 10px;
                margin-left: 20px;
            }
        }
        .row:first-of-type {
            border-bottom: 1px solid #ddd;
        }
    }
    .agreement {
        width: 670px;
        height: 140px;
        font-size: 26px;
        .selectIco {
            width: 28px;
            height: 28px;
            margin-right: 10px;
        }
    }
    .logupBtn {
        width: 360px;
        height: 80px;
        margin-top: 40px;
        color: #fff;
        background: #2e3032;
        border-radius: 40px;
        font-size: 30px;
    }
    .loginWith {
        position: fixed;
        bottom: 30px;
        .txt {
            font-size: 28px;
            b {
                width: 120px;
                height: 2px;
                background: #2e3032;
                display: inline-block;
                margin: 15px;
            }
        }
        .method {
            font-size: 28px;
            margin: 30px 0;
            img {
                width: 82px;
                height: 68px;
            }
            span {
                margin-top: 20px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/login/logup.vue